// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:opsz,wght@14..32,100..900&family=Noto+Sans+JP:wght@100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:root {
  --transition: all 0.3s linear;
  --spacing: 0.25rem;
  --radius: 0.25rem;
  --large-screen-width: 1170px;
  --small-screen-width: 90vw;
  --fixed-width: 50rem;
  --text-size-small: 12px;
  --text-size-normal: 14px;
  --text-size-light-medium: 16px;
  --text-size-medium: 18px;
  --text-size-large: 20px;
  --text-size-x-large: 24px;
  --text-size-xx-large: 32px;
  /* ヘッダーの高さを設定 */
  --header-height: 40px;
  /* フッターの高さを設定 */
  --footer-height: 86px;
  /* メニューの幅を設定 */
  --menu-expand-width: 240px;
  --menu-shrink-width: 64px;
  --menu-current-width: var(--menu-shrink-width);
  --dark-color-dark: #2e3242;
  --dark-color-main: #636978;
  --dark-color-light: #a1a2a8;
  --dark-color-lightest:#b8b9bd;
  --white-color-dark: #D4D6DD;
  --white-color-main: #E8E9F1;
  --white-color-light: #f8f8fb;
  --white-color-lightest: #ffffff;
  --color-bg: #edeef1;
  --primary-color-disabled: #707070;
  --primary-color-light: #434343;
  --primary-color-main: #222222;
  --primary-color-dark: #0f0f0f;
  --primary-color-lightest: #eeeeee;
  --plan-selected-bg: #ffe5ec;
  --success-color-disabled: #97eed9;
  --success-color-light: #43d1b0;
  --success-color-main: #3AC0A0;
  --success-color-dark: #24a98a;
  --warning-color-disabled: #fcd5b9;
  --warning-color-light: #ffc79e;
  --warning-color-main: #FFB37C;
  --warning-color-dark: #e58c4d;
  --danger-color-disabled: #ffacb3;
  --danger-color-light: #ff7a85;
  --danger-color-main: #FF616D;
  --danger-color-dark: #ee4c5a;
  --male-color: #006efd;
  --main-gradation: linear-gradient(60deg, #A9C8FE 6.25%, #D1B6F4 48.44%, #F684AA 90.62%);
  --main-gradation-top:
  radial-gradient(at 92% 62%, hsla(274,93%,74%,1) 0px, transparent 50%),
  radial-gradient(at 49% 2%, hsla(221,83%,64%,1) 0px, transparent 50%),
  radial-gradient(at 73% 60%, hsla(236,97%,66%,1) 0px, transparent 50%),
  radial-gradient(at 54% 25%, hsla(4,60%,75%,1) 0px, transparent 50%),
  radial-gradient(at 72% 73%, hsla(335,86%,73%,1) 0px, transparent 50%),
  radial-gradient(at 41% 50%, hsla(256,83%,77%,1) 0px, transparent 50%),
  radial-gradient(at 37% 15%, hsla(20,98%,64%,1) 0px, transparent 50%);
  --primary-color-main-transparent-75: #222222ce;
  --primary-color-main-transparent-50: #22222288;
  --primary-color-main-transparent-25: #2222223f;
  --dark-color-dark-transparent-75: #3e3f45ce;
  --dark-color-dark-transparent-50: #3e3f4588;
  --dark-color-dark-transparent-25: #3e3f453f;
  --dark-color-dark-transparent-10: #3e3f4517;
  --dark-color-dark-transparent-05: #3e3f450d;
  --white-color-lightest-transparent-85: #ffffffe5;
  --white-color-lightest-transparent-75: #FFFFFFce;
  --white-color-lightest-transparent-50: #FFFFFF88;
  --white-color-lightest-transparent-25: #FFFFFF3f;
  --white-color-lightest-transparent-10: #FFFFFF17;
  --white-color-lightest-transparent-05: #FFFFFF0d;
  --omni-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
  --omni-shadow-hidden: 0 0 8px 0 #38435926;
  --omni-shadow-primary: 0px 0px 8px -14px rgba(0, 111, 253, 0.4), 0px 0px 14px 0px rgba(0, 111, 253, 0.28), 0px 0px 32px 0px rgba(0, 111, 253, 0.24);
  --font_active_color: #2e3242;
  --font_active_sub_color: #636978;
  --font_active_hidden_color: #b2bcca;
  --font_inactive_color: var(--dark-color-main);
  --border-weak-color: #d9dee6;
  --border-color: #c1c7d1;
  --border-active-color: var(--dark-color-dark);
  --hover-color: var(--dark-color-dark-transparent-10);
  --tab-inactive-color: #c1c7d1;
  --input-bg-color: #f7f8f9;
  --input-placeholder-color: #c2c8d2;
  --disabled-bg-color: #dadce0;
  --disabled-border-color: #c1c7d1;
  --disabled-font-color: #838996;
  --scrollbar-color: #c1c7d1;
  --scrollbar-hover-color: #838996;
  --z-index-footer: 400;
  --z-index-header: 500;
  --z-index-overlay: 1000;
  --z-index-menu: 2000;
  --z-index-modal: 3000;
  --z-index-tooltip: 4000;
  --z-index-loading: 9000;
  --z-index-specific-overlay: 9100;
  --z-index-local-over-5: 5;
  --z-index-local-over-4: 4;
  --z-index-local-over-3: 3;
  --z-index-local-over-2: 2;
  --z-index-local-over-1: 1;
  --z-index-local-default: 0;
  --z-index-local-under-1: -1;
  --z-index-local-under-2: -2;
  --z-index-local-under-3: -3;
  --z-index-local-under-4: -4;
  --z-index-local-under-5: -5;
}

.default {
  --primary-color-disabled: #fcb4c0;
  --primary-color-light: #ff869a;
  --primary-color-main: #F44C68;
  --primary-color-dark: #d14059;
  --primary-color-main-transparent-75: #F44C68ce;
  --primary-color-main-transparent-50: #F44C6888;
  --primary-color-main-transparent-25: #F44C683f;
  --primary-color-lightest: #ffe5ec;
}

.recruiting {
  --primary-color-disabled: #7dcd98;
  --primary-color-light: #36cc68;
  --primary-color-main: #23b553;
  --primary-color-dark: #149840;
  --primary-color-main-transparent-75: #23b553ce;
  --primary-color-main-transparent-50: #23b55388;
  --primary-color-main-transparent-25: #23b5533f;
  --primary-color-lightest: #e3f0e0;
}

.product {
  --primary-color-disabled: #97b2db;
  --primary-color-light: #2e82ff;
  --primary-color-main: #0064ff;
  --primary-color-dark: #0749ad;
  --primary-color-main-transparent-75: #0064ffce;
  --primary-color-main-transparent-50: #0064ff88;
  --primary-color-main-transparent-25: #0064ff3f;
  --primary-color-lightest: #e2ecfd;
}

.facility {
  --primary-color-disabled: #ffcc6c;
  --primary-color-light: #ffba3a;
  --primary-color-main: #FFA500;
  --primary-color-dark: #dc8f00;
  --primary-color-main-transparent-75: #FFA500ce;
  --primary-color-main-transparent-50: #FFA50088;
  --primary-color-main-transparent-25: #FFA50021;
  --primary-color-lightest: #fff3d4;
}

.choice {
  --primary-color-disabled: #9b656d;
  --primary-color-light: #c44558;
  --primary-color-main: #a03243;
  --primary-color-dark: #812230;
  --primary-color-main-transparent-75: #a03243ce;
  --primary-color-main-transparent-50: #a0324388;
  --primary-color-main-transparent-25: #a0324321;
  --primary-color-lightest: #f3e2e5;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-thumb {
  background: var(--scrollbar-color);
  border-radius: 8px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--scrollbar-hover-color);
}

::-webkit-scrollbar-track,
::-webkit-scrollbar-corner {
  background: transparent;
}

@supports not selector(::-webkit-scrollbar) {
  * {
    scrollbar-width: thin;
    scrollbar-color: var(--scrollbar-color) transparent;
  }
}
/* styles.scss */
body,
html {
  margin: 0;
  padding: 0;
  height: 100%;
  font-family: "Inter", "Noto Sans JP", -apple-system, BlinkMacSystemFont, "ヒラギノ角ゴ Pro", "Hiragino Kaku Gothic Pro", "メイリオ", Meiryo, sans-serif;
  font-weight: 400;
  background-color: var(--color-bg);
  color: var(--font_active_color);
  display: flex;
  justify-content: center;
  font-size: var(--text-size-normal);
}
body::-webkit-scrollbar,
html::-webkit-scrollbar {
  display: none;
}

a {
  text-decoration: none;
  color: inherit;
  display: block;
}

img {
  width: 100%;
  display: block;
  object-fit: cover;
}

button {
  font-family: "Noto Sans JP", -apple-system, BlinkMacSystemFont, "ヒラギノ角ゴ Pro", "Hiragino Kaku Gothic Pro", "メイリオ", Meiryo, sans-serif;
}

#root {
  height: 100vh;
  width: 100vw;
  flex-basis: auto;
  flex-grow: 1;
  display: flex;
}

.scene-root {
  width: 100%;
  height: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  flex: 1 1;
}

.scene-parent-root {
  width: 100%;
  height: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  flex: 1 1;
}

.content {
  width: 100%;
  height: 100vh;
  max-width: 2000px;
  max-height: 100vh;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  flex: 1 1;
  overflow-y: scroll;
}
.content::-webkit-scrollbar {
  display: none;
}
.content.fullscreen {
  max-width: calc(100vw - 64px);
}
.content.fullscreen.menu-exclude {
  max-width: 100vw;
}

.hide {
  display: none !important;
}

.vertical-hide {
  max-width: 0px !important;
  min-width: 0px !important;
  flex: 0 1 !important;
}

.horizontal-hide {
  height: 0px !important;
  min-height: 0px !important;
  flex: 0 1 !important;
}

/* flex適用 */
.flex {
  display: flex;
}

/* 左寄せ用のスタイル */
.flex-left {
  justify-content: flex-start;
}

/* 右寄せ用のスタイル */
.flex-right {
  justify-content: flex-end;
}

/* 上寄せ用のスタイル */
.flex-top {
  justify-content: flex-start;
}

/* 下寄せ用のスタイル */
.flex-bottom {
  justify-content: flex-end;
}

/* 中央寄せ用のスタイル */
.flex-center {
  justify-content: center;
}

/* 両寄せのスタイル */
.flex-both {
  justify-content: space-between;
}

.align-left {
  align-items: flex-start;
}

.align-center {
  align-items: center;
}

.align-right {
  align-items: flex-end;
}

.align-bottom {
  align-items: flex-end;
}

.align-top {
  align-items: flex-start;
}

.no-padding {
  padding: 0px;
}

.padding-4px {
  padding: 4px;
}

.padding-8px {
  padding: 8px;
}

.padding-12px {
  padding: 12px;
}

.padding-16px {
  padding: 16px;
}

.text-size-small {
  font-size: var(--text-size-small);
}

.text-size-normal {
  font-size: var(--text-size-normal);
}

.text-size-medium {
  font-size: var(--text-size-medium);
}

.text-size-light-medium {
  font-size: var(--text-size-light-medium);
}

.text-size-large {
  font-size: var(--text-size-large);
}

.text-size-x-large {
  font-size: var(--text-size-x-large);
}

.text-size-xx-large {
  font-size: var(--text-size-xx-large);
}

.text-medium {
  font-weight: 600;
  letter-spacing: 1px;
}

.text-semibold {
  font-weight: 700;
  letter-spacing: 1px;
}

.text-bold {
  font-weight: 800;
  letter-spacing: 1px;
}

.text-on-dark {
  color: var(--white-color-main);
}

.text-on-dark-weak {
  color: var(--dark-color-light);
}

.text-color-sub {
  color: var(--font_active_sub_color);
}

.text-color-weak {
  color: var(--font_active_hidden_color);
}

.width-100percent {
  width: 100%;
}

.width-75percent {
  width: 75%;
}

.width-50percent {
  width: 50%;
}

.width-25percent {
  width: 25%;
}

.width-full {
  width: 100%;
}

.height-full {
  height: 100%;
}

.width-fit {
  width: fit-content;
}

.height-fit {
  height: fit-content;
}

.width-120px {
  width: 120px;
}

.width-150px {
  width: 150px;
}

.width-240px {
  width: 240px;
}

.width-280px {
  width: 280px;
}

.width-320px {
  width: 320px;
}

.width-480px {
  width: 480px;
}

.margin-top-16px {
  margin-top: 16px;
}

.margin-top-32px {
  margin-top: 32px;
}

.margin-top-60px {
  margin-top: 60px;
}

.margin-top-90px {
  margin-top: 90px;
}

.margin-top-120px {
  margin-top: 120px;
}

.margin-top-150px {
  margin-top: 150px;
}

.margin-bottom-4px {
  margin-bottom: 4px;
}

.margin-bottom-16px {
  margin-bottom: 16px;
}

.margin-bottom-32px {
  margin-bottom: 32px;
}

.margin-bottom-60px {
  margin-bottom: 60px;
}

.margin-bottom-90px {
  margin-bottom: 90px;
}

.margin-bottom-120px {
  margin-bottom: 120px;
}

.margin-bottom-150px {
  margin-bottom: 150px;
}

.loading {
  position: relative;
  overflow: hidden;
  background-color: var(--white-color-main);
  color: transparent;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}
.loading > * {
  opacity: 0;
}

.loading::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.707) 50%, transparent 100%);
  animation: loading 1.5s infinite;
}

@keyframes loading {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(100%);
  }
}
hr {
  border: none;
  height: 0.5px; /* 線の太さ */
  background-color: var(--border-weak-color); /* 線の色 */
  width: 100%; /* 線の長さ */
}

.input-label-area {
  width: 30%;
}

.input-form-area {
  width: 70%;
}

.relative {
  position: relative;
}

.line-adjusted {
  line-height: 100%;
}

.loading-spinner .loader {
  color: #ffffff;
  font-size: 90px;
  text-indent: -9999em;
  overflow: hidden;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  margin: 72px auto;
  position: relative;
  transform: translateZ(0);
  animation: loading-spinner 1.7s infinite ease, round 1.7s infinite ease;
}
@keyframes loading-spinner {
  0% {
    box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;
  }
  5%, 95% {
    box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;
  }
  10%, 59% {
    box-shadow: 0 -0.83em 0 -0.4em, -0.087em -0.825em 0 -0.42em, -0.173em -0.812em 0 -0.44em, -0.256em -0.789em 0 -0.46em, -0.297em -0.775em 0 -0.477em;
  }
  20% {
    box-shadow: 0 -0.83em 0 -0.4em, -0.338em -0.758em 0 -0.42em, -0.555em -0.617em 0 -0.44em, -0.671em -0.488em 0 -0.46em, -0.749em -0.34em 0 -0.477em;
  }
  38% {
    box-shadow: 0 -0.83em 0 -0.4em, -0.377em -0.74em 0 -0.42em, -0.645em -0.522em 0 -0.44em, -0.775em -0.297em 0 -0.46em, -0.82em -0.09em 0 -0.477em;
  }
  100% {
    box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;
  }
}
@keyframes round {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/globalStyles/styles.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACE,6BAAA;EACA,kBAAA;EACA,iBAAA;EACA,4BAAA;EACA,0BAAA;EACA,oBAAA;EAEA,uBAAA;EACA,wBAAA;EACA,8BAAA;EACA,wBAAA;EACA,uBAAA;EACA,yBAAA;EACA,0BAAA;EAEA,eAAA;EACA,qBAAA;EACA,eAAA;EACA,qBAAA;EAEA,cAAA;EACA,0BAAA;EACA,yBAAA;EACA,8CAAA;EAEA,0BAAA;EACA,0BAAA;EACA,2BAAA;EACA,6BAAA;EAEA,2BAAA;EACA,2BAAA;EACA,4BAAA;EACA,+BAAA;EAEA,mBAAA;EAEA,iCAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EAEA,iCAAA;EAGA,2BAAA;EAEA,iCAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EAEA,iCAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EAEA,gCAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,qBAAA;EAGA,uFAAA;EACA;;;;;;;sEAAA;EAUA,8CAAA;EACA,8CAAA;EACA,8CAAA;EAGA,2CAAA;EACA,2CAAA;EACA,2CAAA;EACA,2CAAA;EACA,2CAAA;EAGA,gDAAA;EACA,gDAAA;EACA,gDAAA;EACA,gDAAA;EACA,gDAAA;EACA,gDAAA;EAEA,8FAAA;EACA,yCAAA;EAEA,mJAAA;EAGA,4BAAA;EACA,gCAAA;EACA,mCAAA;EACA,6CAAA;EAEA,4BAAA;EACA,uBAAA;EACA,6CAAA;EACA,oDAAA;EAEA,6BAAA;EAEA,yBAAA;EACA,kCAAA;EAEA,4BAAA;EACA,gCAAA;EACA,8BAAA;EAEA,0BAAA;EACA,gCAAA;EAIA,qBAAA;EACA,qBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,gCAAA;EAGA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;AAnCF;;AAsCA;EACE,iCAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EAGA,8CAAA;EACA,8CAAA;EACA,8CAAA;EACA,iCAAA;AArCF;;AAuCA;EACE,iCAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EAGA,8CAAA;EACA,8CAAA;EACA,8CAAA;EACA,iCAAA;AAtCF;;AAwCA;EACE,iCAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EAGA,8CAAA;EACA,8CAAA;EACA,8CAAA;EACA,iCAAA;AAvCF;;AA0CA;EACE,iCAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EAGA,8CAAA;EACA,8CAAA;EACA,8CAAA;EACA,iCAAA;AAzCF;;AA2CA;EACE,iCAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EAGA,8CAAA;EACA,8CAAA;EACA,8CAAA;EACA,iCAAA;AA1CF;;AAgDA;EACE,UAAA;EACA,WAAA;AA7CF;;AA+CA;EACE,kCAAA;EACA,kBAAA;AA5CF;;AA8CA;EACE,wCAAA;AA3CF;;AA6CA;;EAEE,uBAAA;AA1CF;;AA4CA;EACE;IACE,qBAAA;IACA,mDAAA;EAzCF;AACF;AA4CA,gBAAA;AACA;;EAEE,SAAA;EACA,UAAA;EACA,YAAA;EACA,6IAAA;EACA,gBAAA;EACA,iCAAA;EACA,+BAAA;EACA,aAAA;EACA,uBAAA;EACA,kCAAA;AA1CF;AA4CE;;EACE,aAAA;AAzCJ;;AA6CA;EACE,qBAAA;EACA,cAAA;EACA,cAAA;AA1CF;;AA6CA;EACE,WAAA;EACA,cAAA;EACA,iBAAA;AA1CF;;AA6CA;EAsBE,oIAAA;AA/DF;;AAkEA;EACE,aAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;AA/DF;;AAkEA;EACE,WAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;AA/DF;;AAkEA;EACE,WAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;AA/DF;;AAkEA;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;AA/DF;AAiEE;EACE,aAAA;AA/DJ;AAkEE;EACE,6BAAA;AAhEJ;AAkEI;EACE,gBAAA;AAhEN;;AAqEA;EACE,wBAAA;AAlEF;;AAqEA;EACE,yBAAA;EACA,yBAAA;EACA,oBAAA;AAlEF;;AAqEA;EACE,sBAAA;EACA,0BAAA;EACA,oBAAA;AAlEF;;AAqEA,WAAA;AACA;EACE,aAAA;AAlEF;;AAqEA,cAAA;AACA;EACE,2BAAA;AAlEF;;AAqEA,cAAA;AACA;EACE,yBAAA;AAlEF;;AAqEA,cAAA;AACA;EACE,2BAAA;AAlEF;;AAqEA,cAAA;AACA;EACE,yBAAA;AAlEF;;AAqEA,eAAA;AACA;EACE,uBAAA;AAlEF;;AAqEA,aAAA;AACA;EACE,8BAAA;AAlEF;;AAqEA;EACE,uBAAA;AAlEF;;AAoEA;EACE,mBAAA;AAjEF;;AAmEA;EACE,qBAAA;AAhEF;;AAmEA;EACE,qBAAA;AAhEF;;AAkEA;EACE,uBAAA;AA/DF;;AAkEA;EACE,YAAA;AA/DF;;AAkEA;EACE,YAAA;AA/DF;;AAkEA;EACE,YAAA;AA/DF;;AAkEA;EACE,aAAA;AA/DF;;AAkEA;EACE,aAAA;AA/DF;;AAkEA;EACE,iCAAA;AA/DF;;AAiEA;EACE,kCAAA;AA9DF;;AAgEA;EACE,kCAAA;AA7DF;;AA+DA;EACE,wCAAA;AA5DF;;AA8DA;EACE,iCAAA;AA3DF;;AA6DA;EACE,mCAAA;AA1DF;;AA4DA;EACE,oCAAA;AAzDF;;AA4DA;EACE,gBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,gBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,gBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA2DA;EACE,8BAAA;AAxDF;;AA2DA;EACE,mCAAA;AAxDF;;AA2DA;EACE,sCAAA;AAxDF;;AA6DA;EACE,WAAA;AA1DF;;AA4DA;EACE,UAAA;AAzDF;;AA2DA;EACE,UAAA;AAxDF;;AA0DA;EACE,UAAA;AAvDF;;AA0DA;EACE,WAAA;AAvDF;;AAyDA;EACE,YAAA;AAtDF;;AAwDA;EACE,kBAAA;AArDF;;AAuDA;EACE,mBAAA;AApDF;;AAuDA;EACE,YAAA;AApDF;;AAsDA;EACE,YAAA;AAnDF;;AAqDA;EACE,YAAA;AAlDF;;AAoDA;EACE,YAAA;AAjDF;;AAmDA;EACE,YAAA;AAhDF;;AAkDA;EACE,YAAA;AA/CF;;AAkDA;EACE,gBAAA;AA/CF;;AAiDA;EACE,gBAAA;AA9CF;;AAgDA;EACE,gBAAA;AA7CF;;AA+CA;EACE,gBAAA;AA5CF;;AA8CA;EACE,iBAAA;AA3CF;;AA6CA;EACE,iBAAA;AA1CF;;AA6CA;EACE,kBAAA;AA1CF;;AA4CA;EACE,mBAAA;AAzCF;;AA2CA;EACE,mBAAA;AAxCF;;AA0CA;EACE,mBAAA;AAvCF;;AAyCA;EACE,mBAAA;AAtCF;;AAwCA;EACE,oBAAA;AArCF;;AAuCA;EACE,oBAAA;AApCF;;AAwCA;EACE,kBAAA;EACA,gBAAA;EACA,yCAAA;EACA,kBAAA;EAEA,oBAAA;EACA,yBAAA;UAAA,iBAAA;AAtCF;AAwCE;EACI,UAAA;AAtCN;;AA0CA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oGAAA;EAMA,gCAAA;AA5CF;;AA+CA;EACE;IACE,4BAAA;EA5CF;EA8CA;IACE,2BAAA;EA5CF;AACF;AA+CA;EACE,YAAA;EACA,aAAA,EAAA,SAAA;EACA,0CAAA,EAAA,QAAA;EACA,WAAA,EAAA,SAAA;AA7CF;;AAgDA;EACE,UAAA;AA7CF;;AA+CA;EACE,UAAA;AA5CF;;AA+CA;EACE,kBAAA;AA5CF;;AA+CA;EACE,iBAAA;AA5CF;;AAiDA;EACE,cAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EAGA,wBAAA;EAEA,uEAAA;AA9CF;AAsEE;EACE;IACE,mHAAA;EAhDJ;EAkDE;IAEE,mHAAA;EAjDJ;EAmDE;IAEE,mJAAA;EAlDJ;EAoDE;IACE,kJAAA;EAlDJ;EAoDE;IACE,gJAAA;EAlDJ;EAoDE;IACE,mHAAA;EAlDJ;AACF;AA8DE;EACE;IAEE,uBAAA;EAlDJ;EAoDE;IAEE,yBAAA;EAlDJ;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:opsz,wght@14..32,100..900&family=Noto+Sans+JP:wght@100..900&display=swap');\r\n\r\n:root {\r\n  --transition: all 0.3s linear;\r\n  --spacing: 0.25rem;\r\n  --radius: 0.25rem;\r\n  --large-screen-width: 1170px;\r\n  --small-screen-width: 90vw;\r\n  --fixed-width: 50rem;\r\n\r\n  --text-size-small:  12px;\r\n  --text-size-normal: 14px;\r\n  --text-size-light-medium: 16px;\r\n  --text-size-medium:  18px;\r\n  --text-size-large:  20px;\r\n  --text-size-x-large:  24px;\r\n  --text-size-xx-large:  32px;\r\n\r\n  /* ヘッダーの高さを設定 */\r\n  --header-height: 40px;\r\n  /* フッターの高さを設定 */\r\n  --footer-height: 86px;\r\n\r\n  /* メニューの幅を設定 */\r\n  --menu-expand-width : 240px;\r\n  --menu-shrink-width : 64px;\r\n  --menu-current-width: var(--menu-shrink-width);\r\n\r\n  --dark-color-dark:    #2e3242;\r\n  --dark-color-main:    #636978;\r\n  --dark-color-light:   #a1a2a8;\r\n  --dark-color-lightest:#b8b9bd;\r\n\r\n  --white-color-dark:     #D4D6DD;\r\n  --white-color-main:     #E8E9F1;\r\n  --white-color-light:    #f8f8fb;\r\n  --white-color-lightest: #ffffff;\r\n\r\n  --color-bg: #edeef1;\r\n\r\n  --primary-color-disabled:  #707070;\r\n  --primary-color-light:  #434343;\r\n  --primary-color-main:   #222222;\r\n  --primary-color-dark:   #0f0f0f;\r\n  // 淡い背景（運営ツールの選択中チップ・ドロップ受け入れ等）\r\n  --primary-color-lightest:   #eeeeee;\r\n\r\n\r\n  --plan-selected-bg:  #ffe5ec;\r\n\r\n  --success-color-disabled:  #97eed9;\r\n  --success-color-light:  #43d1b0;\r\n  --success-color-main:   #3AC0A0;\r\n  --success-color-dark:   #24a98a;\r\n\r\n  --warning-color-disabled:  #fcd5b9;\r\n  --warning-color-light:  #ffc79e;\r\n  --warning-color-main:   #FFB37C;\r\n  --warning-color-dark:   #e58c4d;\r\n\r\n  --danger-color-disabled:   #ffacb3;\r\n  --danger-color-light:   #ff7a85;\r\n  --danger-color-main:    #FF616D;\r\n  --danger-color-dark:    #ee4c5a;\r\n\r\n  --male-color: #006efd;\r\n\r\n  // gradation\r\n  --main-gradation: linear-gradient(60deg, #A9C8FE 6.25%, #D1B6F4 48.44%, #F684AA 90.62%);\r\n  --main-gradation-top: \r\n  radial-gradient(at 92% 62%, hsla(274,93%,74%,1) 0px, transparent 50%),\r\n  radial-gradient(at 49% 2%, hsla(221,83%,64%,1) 0px, transparent 50%),\r\n  radial-gradient(at 73% 60%, hsla(236,97%,66%,1) 0px, transparent 50%),\r\n  radial-gradient(at 54% 25%, hsla(4,60%,75%,1) 0px, transparent 50%),\r\n  radial-gradient(at 72% 73%, hsla(335,86%,73%,1) 0px, transparent 50%),\r\n  radial-gradient(at 41% 50%, hsla(256,83%,77%,1) 0px, transparent 50%),\r\n  radial-gradient(at 37% 15%, hsla(20,98%,64%,1) 0px, transparent 50%);\r\n\r\n  // transparents\r\n  --primary-color-main-transparent-75:   #222222ce;\r\n  --primary-color-main-transparent-50:   #22222288;\r\n  --primary-color-main-transparent-25:   #2222223f;\r\n\r\n  // transparents\r\n  --dark-color-dark-transparent-75:   #3e3f45ce;\r\n  --dark-color-dark-transparent-50:   #3e3f4588;\r\n  --dark-color-dark-transparent-25:   #3e3f453f;\r\n  --dark-color-dark-transparent-10:   #3e3f4517;\r\n  --dark-color-dark-transparent-05:   #3e3f450d;\r\n\r\n  // transparents\r\n  --white-color-lightest-transparent-85:   #ffffffe5;\r\n  --white-color-lightest-transparent-75:   #FFFFFFce;\r\n  --white-color-lightest-transparent-50:   #FFFFFF88;\r\n  --white-color-lightest-transparent-25:   #FFFFFF3f;\r\n  --white-color-lightest-transparent-10:   #FFFFFF17;\r\n  --white-color-lightest-transparent-05:   #FFFFFF0d;\r\n\r\n  --omni-shadow:        rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;\r\n  --omni-shadow-hidden: 0 0 8px 0 #38435926;\r\n\r\n  --omni-shadow-primary:        0px 0px 8px -14px rgba(0, 111, 253, 0.4),  0px 0px 14px 0px rgba(0, 111, 253, 0.28),  0px 0px 32px 0px rgba(0, 111, 253, 0.24);\r\n\r\n\r\n  --font_active_color : #2e3242;\r\n  --font_active_sub_color : #636978;\r\n  --font_active_hidden_color : #b2bcca;\r\n  --font_inactive_color : var(--dark-color-main);\r\n\r\n  --border-weak-color : #d9dee6;\r\n  --border-color : #c1c7d1;\r\n  --border-active-color : var(--dark-color-dark);\r\n  --hover-color : var(--dark-color-dark-transparent-10);\r\n\r\n  --tab-inactive-color : #c1c7d1;\r\n\r\n  --input-bg-color : #f7f8f9;\r\n  --input-placeholder-color : #c2c8d2;\r\n\r\n  --disabled-bg-color : #dadce0;\r\n  --disabled-border-color : #c1c7d1;\r\n  --disabled-font-color : #838996;\r\n\r\n  --scrollbar-color: #c1c7d1;\r\n  --scrollbar-hover-color: #838996;\r\n\r\n  // z-index指定 アプリケーション内では変数のみで管理する\r\n  // グローバルz-index\r\n  --z-index-footer:   400;\r\n  --z-index-header:   500;\r\n  --z-index-overlay:  1000;\r\n  --z-index-menu:     2000;\r\n  --z-index-modal:    3000;\r\n  --z-index-tooltip:  4000;\r\n  --z-index-loading:  9000;\r\n  --z-index-specific-overlay:  9100;\r\n\r\n  // ローカルz-index\r\n  --z-index-local-over-5:   5;\r\n  --z-index-local-over-4:   4;\r\n  --z-index-local-over-3:   3;\r\n  --z-index-local-over-2:   2;\r\n  --z-index-local-over-1:   1;\r\n  --z-index-local-default:  0;\r\n  --z-index-local-under-1: -1;\r\n  --z-index-local-under-2: -2;\r\n  --z-index-local-under-3: -3;\r\n  --z-index-local-under-4: -4;\r\n  --z-index-local-under-5: -5;\r\n}\r\n\r\n.default{\r\n  --primary-color-disabled:  #fcb4c0;\r\n  --primary-color-light:  #ff869a;\r\n  --primary-color-main:   #F44C68;\r\n  --primary-color-dark:   #d14059;\r\n\r\n  // transparents\r\n  --primary-color-main-transparent-75:   #F44C68ce;\r\n  --primary-color-main-transparent-50:   #F44C6888;\r\n  --primary-color-main-transparent-25:   #F44C683f;\r\n  --primary-color-lightest:   #ffe5ec;\r\n}\r\n.recruiting{\r\n  --primary-color-disabled:  #7dcd98;\r\n  --primary-color-light:  #36cc68;\r\n  --primary-color-main:   #23b553;\r\n  --primary-color-dark:   #149840;\r\n\r\n  // transparents\r\n  --primary-color-main-transparent-75:   #23b553ce;\r\n  --primary-color-main-transparent-50:   #23b55388;\r\n  --primary-color-main-transparent-25:   #23b5533f;\r\n  --primary-color-lightest:   #e3f0e0;\r\n}\r\n.product{\r\n  --primary-color-disabled:  #97b2db;\r\n  --primary-color-light:  #2e82ff;\r\n  --primary-color-main:   #0064ff;\r\n  --primary-color-dark:   #0749ad;\r\n\r\n  // transparents\r\n  --primary-color-main-transparent-75:   #0064ffce;\r\n  --primary-color-main-transparent-50:   #0064ff88;\r\n  --primary-color-main-transparent-25:   #0064ff3f;\r\n  --primary-color-lightest:   #e2ecfd;\r\n}\r\n\r\n.facility{\r\n  --primary-color-disabled:  #ffcc6c;\r\n  --primary-color-light:  #ffba3a;\r\n  --primary-color-main:   #FFA500;\r\n  --primary-color-dark:   #dc8f00;\r\n\r\n  // transparents\r\n  --primary-color-main-transparent-75:   #FFA500ce;\r\n  --primary-color-main-transparent-50:   #FFA50088;\r\n  --primary-color-main-transparent-25:   #FFA50021;\r\n  --primary-color-lightest:   #fff3d4;\r\n}\r\n.choice{\r\n  --primary-color-disabled:  #9b656d;\r\n  --primary-color-light:  #c44558;\r\n  --primary-color-main:   #a03243;\r\n  --primary-color-dark:   #812230;\r\n\r\n  // transparents\r\n  --primary-color-main-transparent-75:   #a03243ce;\r\n  --primary-color-main-transparent-50:   #a0324388;\r\n  --primary-color-main-transparent-25:   #a0324321;\r\n  --primary-color-lightest:   #f3e2e5;\r\n}\r\n\r\n// スクロールバー（管理画面全体で共通。細いつまみのみで、背景は透明）\r\n// ※ scrollbar-width / scrollbar-color を指定すると Chrome は ::-webkit-scrollbar を無視して矢印付きになるため、\r\n//    標準プロパティは ::-webkit-scrollbar 非対応のブラウザ（Firefox）にだけ当てる\r\n::-webkit-scrollbar {\r\n  width: 6px;\r\n  height: 6px;\r\n}\r\n::-webkit-scrollbar-thumb {\r\n  background: var(--scrollbar-color);\r\n  border-radius: 8px;\r\n}\r\n::-webkit-scrollbar-thumb:hover {\r\n  background: var(--scrollbar-hover-color);\r\n}\r\n::-webkit-scrollbar-track,\r\n::-webkit-scrollbar-corner {\r\n  background: transparent;\r\n}\r\n@supports not selector(::-webkit-scrollbar) {\r\n  * {\r\n    scrollbar-width: thin;\r\n    scrollbar-color: var(--scrollbar-color) transparent;\r\n  }\r\n}\r\n\r\n/* styles.scss */\r\nbody,\r\nhtml {\r\n  margin: 0;\r\n  padding: 0;\r\n  height: 100%;;\r\n  font-family: \"Inter\", \"Noto Sans JP\", -apple-system, BlinkMacSystemFont, \"ヒラギノ角ゴ Pro\", \"Hiragino Kaku Gothic Pro\", \"メイリオ\", Meiryo, sans-serif;\r\n  font-weight: 400; \r\n  background-color: var(--color-bg);\r\n  color: var(--font_active_color);\r\n  display: flex;\r\n  justify-content: center;\r\n  font-size: var(--text-size-normal);\r\n\r\n  &::-webkit-scrollbar {\r\n    display: none;\r\n  }\r\n}\r\n\r\na {\r\n  text-decoration: none;\r\n  color: inherit;\r\n  display: block;\r\n}\r\n\r\nimg {\r\n  width: 100%;\r\n  display: block;\r\n  object-fit: cover;\r\n}\r\n\r\nbutton{\r\n  // font-style: inherit;\r\n  // font-variant-ligatures: inherit;\r\n  // font-variant-caps: inherit;\r\n  // font-variant-numeric: inherit;\r\n  // font-variant-east-asian: inherit;\r\n  // font-variant-alternates: inherit;\r\n  // font-variant-position: inherit;\r\n  // font-variant-emoji: inherit;\r\n  // font-stretch: inherit;\r\n  // font-optical-sizing: inherit;\r\n  // font-size-adjust: inherit;\r\n  // font-kerning: inherit;\r\n  // font-feature-settings: inherit;\r\n  // font-variation-settings: inherit;\r\n  // text-rendering: auto;\r\n  // word-spacing: normal;\r\n  // line-height: normal;\r\n  // text-transform: none;\r\n  // text-indent: 0px;\r\n  // text-shadow: none;\r\n  // cursor: default;\r\n  font-family: \"Noto Sans JP\", -apple-system, BlinkMacSystemFont, \"ヒラギノ角ゴ Pro\", \"Hiragino Kaku Gothic Pro\", \"メイリオ\", Meiryo, sans-serif;\r\n}\r\n\r\n#root {\r\n  height: 100vh;\r\n  width: 100vw;\r\n  flex-basis: auto;\r\n  flex-grow: 1;\r\n  display: flex;\r\n}\r\n\r\n.scene-root{\r\n  width: 100%;\r\n  height: fit-content;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-direction: column;\r\n  flex: 1;\r\n}\r\n\r\n.scene-parent-root{\r\n  width: 100%;\r\n  height: fit-content;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-direction: column;\r\n  flex: 1;\r\n}\r\n\r\n.content {\r\n  width: 100%;\r\n  height: 100vh;\r\n  max-width: 2000px;\r\n  max-height: 100vh;\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  flex-direction: column;\r\n  flex: 1;\r\n  overflow-y: scroll;\r\n\r\n  &::-webkit-scrollbar {\r\n    display: none;\r\n  }\r\n\r\n  &.fullscreen{\r\n    max-width: calc(100vw - 64px);\r\n\r\n    &.menu-exclude{\r\n      max-width: 100vw;\r\n    }\r\n  }\r\n}\r\n\r\n.hide{\r\n  display: none !important;\r\n}\r\n\r\n.vertical-hide{\r\n  max-width: 0px !important;\r\n  min-width: 0px !important;\r\n  flex: 0 !important;\r\n}\r\n\r\n.horizontal-hide{\r\n  height: 0px !important;\r\n  min-height: 0px !important;\r\n  flex: 0 !important;\r\n}\r\n\r\n/* flex適用 */\r\n.flex {\r\n  display: flex;\r\n}\r\n\r\n/* 左寄せ用のスタイル */\r\n.flex-left {\r\n  justify-content: flex-start;\r\n}\r\n\r\n/* 右寄せ用のスタイル */\r\n.flex-right {\r\n  justify-content: flex-end;\r\n}\r\n\r\n/* 上寄せ用のスタイル */\r\n.flex-top {\r\n  justify-content: flex-start;\r\n}\r\n\r\n/* 下寄せ用のスタイル */\r\n.flex-bottom {\r\n  justify-content: flex-end;\r\n}\r\n\r\n/* 中央寄せ用のスタイル */\r\n.flex-center {\r\n  justify-content: center;\r\n}\r\n\r\n/* 両寄せのスタイル */\r\n.flex-both {\r\n  justify-content: space-between;\r\n}\r\n\r\n.align-left{\r\n  align-items: flex-start;\r\n}\r\n.align-center{\r\n  align-items: center;\r\n}\r\n.align-right{\r\n  align-items: flex-end;\r\n}\r\n\r\n.align-bottom{\r\n  align-items: flex-end;\r\n}\r\n.align-top{\r\n  align-items: flex-start;\r\n}\r\n\r\n.no-padding{\r\n  padding: 0px;\r\n}\r\n\r\n.padding-4px{\r\n  padding: 4px;\r\n}\r\n\r\n.padding-8px{\r\n  padding: 8px;\r\n}\r\n\r\n.padding-12px{\r\n  padding: 12px;\r\n}\r\n\r\n.padding-16px{\r\n  padding: 16px;\r\n}\r\n\r\n.text-size-small{\r\n  font-size: var(--text-size-small);\r\n}\r\n.text-size-normal{\r\n  font-size: var(--text-size-normal);\r\n}\r\n.text-size-medium{\r\n  font-size: var(--text-size-medium);\r\n}\r\n.text-size-light-medium{\r\n  font-size: var(--text-size-light-medium);\r\n}\r\n.text-size-large{\r\n  font-size: var(--text-size-large);\r\n}\r\n.text-size-x-large{\r\n  font-size: var(--text-size-x-large);\r\n}\r\n.text-size-xx-large{\r\n  font-size: var(--text-size-xx-large);\r\n}\r\n\r\n.text-medium{\r\n  font-weight: 600;\r\n  letter-spacing: 1px;\r\n}\r\n\r\n.text-semibold{\r\n  font-weight: 700;\r\n  letter-spacing: 1px;\r\n}\r\n\r\n.text-bold{\r\n  font-weight: 800;\r\n  letter-spacing: 1px;\r\n}\r\n\r\n.text-on-dark{\r\n  color: var(--white-color-main);\r\n}\r\n.text-on-dark-weak{\r\n  color: var(--dark-color-light);\r\n}\r\n\r\n.text-color-sub{\r\n  color: var(--font_active_sub_color);\r\n}\r\n\r\n.text-color-weak{\r\n  color: var(--font_active_hidden_color);\r\n}\r\n\r\n\r\n\r\n.width-100percent{\r\n  width: 100%;\r\n}\r\n.width-75percent{\r\n  width: 75%;\r\n}\r\n.width-50percent{\r\n  width: 50%;\r\n}\r\n.width-25percent{\r\n  width: 25%;\r\n}\r\n\r\n.width-full{\r\n  width: 100%;\r\n}\r\n.height-full{\r\n  height: 100%;\r\n}\r\n.width-fit{\r\n  width: fit-content;\r\n}\r\n.height-fit{\r\n  height: fit-content;\r\n}\r\n\r\n.width-120px{\r\n  width: 120px;\r\n}\r\n.width-150px{\r\n  width: 150px;\r\n}\r\n.width-240px{\r\n  width: 240px;\r\n}\r\n.width-280px{\r\n  width: 280px;\r\n}\r\n.width-320px{\r\n  width: 320px;\r\n}\r\n.width-480px{\r\n  width: 480px;\r\n}\r\n\r\n.margin-top-16px{\r\n  margin-top: 16px;\r\n}\r\n.margin-top-32px{\r\n  margin-top: 32px;\r\n}\r\n.margin-top-60px{\r\n  margin-top: 60px;\r\n}\r\n.margin-top-90px{\r\n  margin-top: 90px;\r\n}\r\n.margin-top-120px{\r\n  margin-top: 120px;\r\n}\r\n.margin-top-150px{\r\n  margin-top: 150px;\r\n}\r\n\r\n.margin-bottom-4px{\r\n  margin-bottom: 4px;\r\n}\r\n.margin-bottom-16px{\r\n  margin-bottom: 16px;\r\n}\r\n.margin-bottom-32px{\r\n  margin-bottom: 32px;\r\n}\r\n.margin-bottom-60px{\r\n  margin-bottom: 60px;\r\n}\r\n.margin-bottom-90px{\r\n  margin-bottom: 90px;\r\n}\r\n.margin-bottom-120px{\r\n  margin-bottom: 120px;\r\n}\r\n.margin-bottom-150px{\r\n  margin-bottom: 150px;\r\n}\r\n\r\n\r\n.loading {\r\n  position: relative;\r\n  overflow: hidden;\r\n  background-color: var(--white-color-main);\r\n  color: transparent;\r\n\r\n  pointer-events: none;\r\n  user-select: none;\r\n\r\n  &> * {\r\n      opacity: 0;\r\n  }\r\n}\r\n\r\n.loading::after {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: linear-gradient(\r\n    90deg,\r\n    transparent 0%,\r\n    rgba(255, 255, 255, 0.707) 50%,\r\n    transparent 100%\r\n  );\r\n  animation: loading 1.5s infinite;\r\n}\r\n\r\n@keyframes loading {\r\n  from {\r\n    transform: translateX(-100%);\r\n  }\r\n  to {\r\n    transform: translateX(100%);\r\n  }\r\n}\r\n\r\nhr{\r\n  border: none;\r\n  height: 0.5px; /* 線の太さ */\r\n  background-color: var(--border-weak-color);/* 線の色 */\r\n  width: 100%; /* 線の長さ */\r\n}\r\n\r\n.input-label-area{\r\n  width: 30%;\r\n}\r\n.input-form-area{\r\n  width: 70%;\r\n}\r\n\r\n.relative{\r\n  position: relative;\r\n}\r\n\r\n.line-adjusted{\r\n  line-height: 100%;\r\n}\r\n\r\n\r\n\r\n.loading-spinner .loader {\r\n  color: #ffffff;\r\n  font-size: 90px;\r\n  text-indent: -9999em;\r\n  overflow: hidden;\r\n  width: 1em;\r\n  height: 1em;\r\n  border-radius: 50%;\r\n  margin: 72px auto;\r\n  position: relative;\r\n  -webkit-transform: translateZ(0);\r\n  -ms-transform: translateZ(0);\r\n  transform: translateZ(0);\r\n  -webkit-animation: loading-spinner 1.7s infinite ease, round 1.7s infinite ease;\r\n  animation: loading-spinner 1.7s infinite ease, round 1.7s infinite ease;\r\n\r\n  @-webkit-keyframes loading-spinner {\r\n    0% {\r\n      box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;\r\n    }\r\n    5%,\r\n    95% {\r\n      box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;\r\n    }\r\n    10%,\r\n    59% {\r\n      box-shadow: 0 -0.83em 0 -0.4em, -0.087em -0.825em 0 -0.42em, -0.173em -0.812em 0 -0.44em, -0.256em -0.789em 0 -0.46em, -0.297em -0.775em 0 -0.477em;\r\n    }\r\n    20% {\r\n      box-shadow: 0 -0.83em 0 -0.4em, -0.338em -0.758em 0 -0.42em, -0.555em -0.617em 0 -0.44em, -0.671em -0.488em 0 -0.46em, -0.749em -0.34em 0 -0.477em;\r\n    }\r\n    38% {\r\n      box-shadow: 0 -0.83em 0 -0.4em, -0.377em -0.74em 0 -0.42em, -0.645em -0.522em 0 -0.44em, -0.775em -0.297em 0 -0.46em, -0.82em -0.09em 0 -0.477em;\r\n    }\r\n    100% {\r\n      box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;\r\n    }\r\n  }\r\n  @keyframes loading-spinner {\r\n    0% {\r\n      box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;\r\n    }\r\n    5%,\r\n    95% {\r\n      box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;\r\n    }\r\n    10%,\r\n    59% {\r\n      box-shadow: 0 -0.83em 0 -0.4em, -0.087em -0.825em 0 -0.42em, -0.173em -0.812em 0 -0.44em, -0.256em -0.789em 0 -0.46em, -0.297em -0.775em 0 -0.477em;\r\n    }\r\n    20% {\r\n      box-shadow: 0 -0.83em 0 -0.4em, -0.338em -0.758em 0 -0.42em, -0.555em -0.617em 0 -0.44em, -0.671em -0.488em 0 -0.46em, -0.749em -0.34em 0 -0.477em;\r\n    }\r\n    38% {\r\n      box-shadow: 0 -0.83em 0 -0.4em, -0.377em -0.74em 0 -0.42em, -0.645em -0.522em 0 -0.44em, -0.775em -0.297em 0 -0.46em, -0.82em -0.09em 0 -0.477em;\r\n    }\r\n    100% {\r\n      box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;\r\n    }\r\n  }\r\n  @-webkit-keyframes round {\r\n    0% {\r\n      -webkit-transform: rotate(0deg);\r\n      transform: rotate(0deg);\r\n    }\r\n    100% {\r\n      -webkit-transform: rotate(360deg);\r\n      transform: rotate(360deg);\r\n    }\r\n  }\r\n  @keyframes round {\r\n    0% {\r\n      -webkit-transform: rotate(0deg);\r\n      transform: rotate(0deg);\r\n    }\r\n    100% {\r\n      -webkit-transform: rotate(360deg);\r\n      transform: rotate(360deg);\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
